import { createUsageTracker, createWebSessionStore } from '@rhwb/usage';
import { callCloudRun } from './cloudRun';

/**
 * App-usage tracking for the runner dashboard.
 *
 * A module singleton: the session outlives every component, and a tracker
 * rebuilt on re-render would mint a new session id each time.
 *
 * Note that this app is a single dashboard screen plus three secondary routes,
 * so its page breakdown is inherently coarse — most time lands on `dashboard`.
 * Session counts and adoption are the numbers worth reading here.
 */
export const usageTracker = createUsageTracker({
  app: 'runner',
  platform: 'web',
  appVersion: process.env.REACT_APP_VERSION || null,
  store: createWebSessionStore(),
  send: (beat) => callCloudRun('/api/usage/heartbeat', beat).catch(() => {}),
});

export default usageTracker;
